exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".paper-canvas_paper-canvas_1y588 {\n    width: 480px;\n    height: 360px;\n    margin: auto;\n    position: absolute;\n    background-color: #fff;\n}\n", ""]);

// exports
exports.locals = {
	"paper-canvas": "paper-canvas_paper-canvas_1y588",
	"paperCanvas": "paper-canvas_paper-canvas_1y588"
};